import type { GrowthOverviewResponse } from "../growthOverviewApiTypes";
import type { IGrowthOverviewTableRow } from "../types";
import { GrowthOverviewLevel } from "../types";

import { appendRowsWithDedup } from "./growthOverviewPaginationUtils";
import { mapBranchResponseToTableRows } from "./mapApiRows";

interface IMergeBranchIntoTreeOptions {
    append?: boolean;
}

export const mergeBranchIntoTree = (
    rows: IGrowthOverviewTableRow[],
    parentRowId: string,
    response: GrowthOverviewResponse,
    options: IMergeBranchIntoTreeOptions = {},
): IGrowthOverviewTableRow[] => {
    const childRows = mapBranchResponseToTableRows(response);

    const patchRow = (row: IGrowthOverviewTableRow): IGrowthOverviewTableRow => {
        if (row.id === parentRowId) {
            if (response.level === GrowthOverviewLevel.Domains) {
                const nextChildren = options.append ? appendRowsWithDedup(row.children ?? [], childRows) : childRows;

                return {
                    ...row,
                    children: nextChildren.length > 0 ? nextChildren : [],
                    childrenLoaded: true,
                    totalDomainCount: response.totalCount,
                };
            }

            if (response.level === GrowthOverviewLevel.SubIndustries) {
                const nextChildren = options.append ? appendRowsWithDedup(row.children ?? [], childRows) : childRows;

                return {
                    ...row,
                    children: nextChildren.length > 0 ? nextChildren : [],
                    childrenLoaded: true,
                    totalSubIndustryCount: response.totalCount,
                };
            }

            return {
                ...row,
                children: childRows.length > 0 ? childRows : [],
                childrenLoaded: true,
            };
        }

        if (row.children?.length) {
            return {
                ...row,
                children: row.children.map(patchRow),
            };
        }

        return row;
    };

    return rows.map(patchRow);
};
